const TYPES = {
  INavigationControllerFactory: Symbol.for('INavigationControllerFactory')
};

export { TYPES };
